import { DecimalPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input, OnInit } from '@angular/core'

@Component({
  selector: 'circular-progress',
  imports: [DecimalPipe],
  templateUrl: './circular-progress.html',
  styleUrls: ['./circular-progress.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CircularProgress implements OnInit {
  percentage = input<number>(0)

  color = computed(() => '#00B575')

  circumference = 326

  ngOnInit(): void {
    this.setShadowColor()
  }

  setShadowColor(): void {
    document.documentElement.style.setProperty('--progress-shadow-color', this.color())
  }

  get strokeDashoffset(): number {
    const radius = 45
    const circumference = 2 * Math.PI * radius

    const per = this.percentage() > 100 ? 100 : this.percentage()
    return circumference - (per / 100) * circumference
  }
}
